export default "/images/0d8e16cef6733ea4f91bf4a6edba5d8e.avif";